var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import ConfigsManager from './configs';
import { rtcVersion } from './version';
export var LogFactory = function (component) {
    return {
        log: function () {
            var variables = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                variables[_i] = arguments[_i];
            }
            if (ConfigsManager.logging) {
                // tslint:disable-next-line:no-console
                console.log.apply(console, __spread(["@jive/rtc@" + rtcVersion + " -> " + component + ":"], variables));
            }
        },
        warn: function () {
            var variables = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                variables[_i] = arguments[_i];
            }
            if (ConfigsManager.logging) {
                console.warn.apply(console, __spread(["@jive/rtc@" + rtcVersion + " -> " + component + ":"], variables));
            }
        },
        error: function () {
            var variables = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                variables[_i] = arguments[_i];
            }
            // Errors should always be logged.
            console.error.apply(console, __spread(["@jive/rtc@" + rtcVersion + " -> " + component + ":"], variables));
        }
    };
};
//# sourceMappingURL=logging.js.map